module.exports = __webpack_public_path__ + "static/media/trintas_logo_clients_small.598fead4.png";